<template>
  <div class="">
    <credentials> </credentials>
  </div>
</template>

<script>
import Credentials from "@/components/profile/emessage/credentials/index.vue";
export default {
  props: {
    msg: String,
  },
  components: {
    Credentials,
  },
  created() {},
};
</script>
